export default {
    creationForm: 'PROFILE_CREATION_FORM',
    qrcodeSetup: 'QRCODE_SETUP',
    selectedCategories: 'SELECTED_CATEGORIES',
};
